import React, { useEffect, useState } from 'react'
import img5 from '../Assets/video5.png.png'
import { Get_Api } from '../Api_Url';
import { useNavigate } from 'react-router-dom';

function LatestBlogs() {
    const navigate = useNavigate();
    const [AllBlogs, setAllBlogs] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);
    const getBlogs = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllBlogs`);
            setAllBlogs(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getBlogs();
    }, []);

    const Blogdetail = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/BlogDetils/${id}`)
    }

    return (
        <div>
            <div className='RecentBlogs'>
                <p>Recent Blogs</p>
                <h3>Best <span>Destinations</span> for
                    <br />Thrill Seekers</h3>
                <br />
                <br />
                <div className='unique-blog-cards'>
                    {AllBlogs?.map((item) => (
                        <div>
                            <div className='unique-blog-card' onClick={() => Blogdetail(item?._id)}>
                                <img src={item?.Image || img5} />
                                <br />
                                <div className='unique-blog-d'>
                                    <p><i class="bi bi-person-fill"></i>Freddie Parker</p>
                                    <p><i class="bi bi-file-earmark"></i>Politics</p>
                                </div>
                                <h3>{item?.Name}</h3>
                                <br />
                                <button>Read More</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default LatestBlogs